<template>
 <div>
    <div class="video_wrapper">
      <div class="video_block">
        <video-player  class="video-player-box"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
          @loadeddata="onPlayerLoadeddata($event)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying($event)"
          @timeupdate="onPlayerTimeupdate($event)"
          @canplay="onPlayerCanplay($event)"
          @canplaythrough="onPlayerCanplaythrough($event)"
          @ready="playerReadied"
          @statechanged="playerStateChanged($event)">
        </video-player>
      </div>
    </div>
    <div class="webcam_wrapper">
      <Webcam v-if="showWebcam" @showWebcam="showHideWebcam" :showWebcam="showWebcam" :captureCount="captureCount"></Webcam>
    </div>
  </div>
</template>

<script>
import Webcam from '@/components/template/Webcam'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
// var $ = require('jquery')
var Cookies = require('vue-cookies')
var userPermissions = Cookies.get('userPermissions')

export default {
  components: {
    videoPlayer,
    Webcam
  },
  name: 'Uploadedvideo',
  props: ['videoId'],
  data () {
    return {
      videoDuration: 0,
      imageCount: 4,
      captureCount: 1,
      pauseTimestamp: 0,
      pauseTimeSlot1: 0,
      pauseTimeSlot2: 0,
      pauseTimeSlot3: 0,
      pauseTimeSlot4: 0,
      checkPauseInterval: '',
      showWebcam: false,
      isSetCues: false,
      isVideoEnded: false,

      playerOptions: {
        height: '360',
        autoplay: true,
        muted: true,
        language: 'en',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: ''
        }],
        poster: '/media/misc/empty_video_screen.jpg'
      }
    }
  },
  beforeCreate: function () {
    if (!userPermissions.course_view) {
      this.$router.push('/')
    }
  },
  mounted () {
    console.log('uploaded video component loaded')
    this.playerOptions.sources.forEach(options => {
      options.src = this.videoId
      options.type = 'video/mp4'
    })
  },
  beforeDestroy: function () {
    clearInterval(this.checkPauseInterval)
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    //  listen event
    onPlayerPlay (player) {
      console.log('player play!', player)
      var self = this
      this.checkPauseInterval = setInterval(function () {
        if (player) {
          var currentTime = parseInt(player.currentTime())
          if (self.captureCount === 1 && self.pauseTimeSlot1 === parseInt(currentTime)) {
            self.setWebcamCapture(self)
          }
          if (self.captureCount < 3 && self.pauseTimeSlot2 === parseInt(currentTime)) {
            self.setWebcamCapture(self)
          }
          if (self.captureCount < 4 && self.pauseTimeSlot3 === parseInt(currentTime)) {
            self.setWebcamCapture(self)
          }
          if (self.captureCount < 5 && self.pauseTimeSlot4 === parseInt(currentTime)) {
            self.setWebcamCapture(self)
          }
        }
      }, 1000)
    },
    onPlayerPause (player) {
      // console.log('player pause!', player)
    },
    onPlayerEnded (player) {
      console.log('player ended!', player)
      this.isVideoEnded = true
      this.showWebcam = true
      clearInterval(this.checkPauseInterval)
      this.$emit('change-video-desc')
    },
    onPlayerLoadeddata (player) {
      console.log('player Loadeddata!', player.duration())
      this.videoDuration = player.duration()
      if (!this.isSetCues) {
        var timeSlot = parseInt(this.videoDuration / this.imageCount)
        this.isSetCues = true
        for (let index = 0; index < this.imageCount; index++) {
          var randomTimeSlot = Math.floor(Math.random() * timeSlot + 1)
          var pauseTime = this.pauseTimestamp + randomTimeSlot
          this.pauseTimestamp += timeSlot
          if (index === 0) {
            this.pauseTimeSlot1 = pauseTime
          }
          if (index === 1) {
            this.pauseTimeSlot2 = pauseTime
          }
          if (index === 2) {
            this.pauseTimeSlot3 = pauseTime
          }
          if (index === 3) {
            this.pauseTimeSlot4 = pauseTime
          }
        }
      }
    },
    onPlayerWaiting (player) {
      // console.log('player Waiting!', player)
    },
    onPlayerPlaying (player) {
      // console.log('player Playing!', player)
    },
    onPlayerTimeupdate (player) {
      // console.log('player Timeupdate!', player.currentTime())
    },
    onPlayerCanplay (player) {
      // console.log('player Canplay!', player)
    },
    onPlayerCanplaythrough (player) {
      // console.log('player Canplaythrough!', player)
    },
    //  or listen state event
    playerStateChanged (playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },
    //  player is ready
    playerReadied (player) {
      console.log('example player 1 readied', player)
    },
    setWebcamCapture (event) {
      this.showWebcam = true
      this.player.pause()
      clearInterval(this.checkPauseInterval)
    },
    showHideWebcam (status) {
      this.showWebcam = status
      if (!this.isVideoEnded) {
        this.captureCount++
        this.player.play()
      } else {
        this.captureCount = 0
      }
    }
  }
}
</script>

<style scoped>
.subject_icon_block {
    height: 100%;
}
</style>
